import type { TField } from './types';

export const LOGIN_FIELDS = {
  PURCHASE_ORDER_NO: 'purchaseOrderNo' as TField,
  KEY: 'vaultKey' as TField,
};
